import moment from 'moment';
import type { AfDate } from '@Types';
import type { Moment } from 'moment';
import { getParsedDate, isAfDate } from '@Helpers';

export type CartDateValue = AfDate | string | number | null | undefined;

/**
 * Parse cart date fields (intake_date, outcome_date, paid_date, etc.)
 * from AfDate, epoch, or shelter-formatted datetime strings.
 */
export function parseCartDateMoment(date: CartDateValue): Moment | null {
  if (date == null || date === '') return null;

  if (isAfDate(date)) {
    const parsed = moment(Number(date.$date.$numberLong));

    return parsed.isValid() ? parsed : null;
  }

  if (typeof date === 'number') {
    const parsed = moment(date);

    return parsed.isValid() ? parsed : null;
  }

  if (typeof date === 'string') {
    if (/^\d+$/.test(date)) {
      const parsed = moment(Number(date));

      return parsed.isValid() ? parsed : null;
    }

    const parsed = getParsedDate(date);

    return parsed ? moment(parsed) : null;
  }

  return null;
}
